import React, { useEffect, useState } from "react";
import {
  sourceSchema,
  expression_parseFromSource,
} from "./surveyAdapterMemberPortal.const";
import Ajv from "ajv";
import jsonata from "jsonata";
import { LANGUAGES } from "../../constants/supported_lang";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
const getLanguageId = (languageCode: any) => {
  const language = LANGUAGES.find((lang) => lang.code === languageCode);
  return language ? language.id : null; // Return the id or null if not found
};
export const useSurveyAdapterMemeberPortal = (rawSurveyData: any) => {
  console.log("rawSurveyData000", rawSurveyData?.PreferredLanguage);
  const location = useLocation();
    const languageConfirmed = sessionStorage.getItem("languageConfirmed");
    console.log("languageConfirmed---", languageConfirmed);
  // let { rawSurveyData } = location.state;
  // console.log("rawSurveyData999", rawSurveyData.PreferredLanguage);
  const appUiState = useSelector((state: any) => state.portal.uiState);
  //const appLanguage = getLanguageId(appUiState?.Language);
   const appLanguage = appUiState?.Language;
  console.log("appLanguage===", appLanguage);
  //const appLanguage = rawSurveyData.PreferredLanguage;
  console.log("raw");
  let languageId;

  if (languageConfirmed === "false") {
    languageId = getLanguageId(appLanguage);
  } else {
    languageId = languageConfirmed
      ? rawSurveyData?.PreferredLanguage
      : getLanguageId(appLanguage);
  }
  let languageData = localStorage.getItem("languageData");
  const ajv = new Ajv();
  const [sourceData, setSourceData] = useState<any>();
  //const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const parseFromSource = async (sourceData: any) => {
    const validate = ajv.compile(sourceSchema);
    const valid = validate(sourceData);

    if (valid) {
      setSourceData(sourceData);
      const expression = jsonata(expression_parseFromSource);
      let parsedRecords = await expression.evaluate(sourceData);
      return parsedRecords;
    } else {
      // alert('Source data is invalid');
      return await false;
    }
  };
  const parseToSource = async (parsedData: any, isPartial: boolean = false) => {
    // const parseToSource = async (parsedData: any, isPartial: boolean) => {
    const delay = () => new Promise((resolve) => setTimeout(resolve, 0));
    parsedData.pages.forEach((p: any, pIndex: any) => {
      p.questionGroups.forEach((qg: any, gIndex: any) => {
        qg.questions.forEach((q: any, qIndex: any) => {
          console.log();
          syncQuestionChanges(q);
        });
      });
    });
    await delay();
    let finalData = {};
    if (sourceData.IsPartialSaveEnabled && isPartial === true) {
      finalData = {
        ...sourceData,
        LastUpdatedPageNumber: parsedData.lastUpdatedPageNumber,
        PreferredLanguage: languageId,
        surveyPages: sourceData.surveyPages
          .filter((el: any) =>
            parsedData.pages.some((pg) => pg.pageNumber === el.pageNumber)
          )
          .map((el: any) => {
            const updatedSurveyQuestions = el.surveyQuestions.map(
              (question: any) => {
                if (!question.surveyQuestionChoices) {
                  console.error(
                    "surveyQuestionChoices is missing for:",
                    question
                  );
                  return { ...question };
                }

                let englishResponse = "";

                if (question.questionType == 120000001) {
                  const matchedIndices = question.Response.map((responseItem) =>
                    question.surveyQuestionChoices.findIndex(
                      (choice: any) => choice.choiceText === responseItem.value
                    )
                  );
                  question.EnglishChoice =
                    Array.isArray(question.EnglishChoice) &&
                    question.EnglishChoice.length > 0
                      ? [question.EnglishChoice.join(question.FieldDelimiter)]
                      : [];
                  const choices = question.EnglishChoice[0].split("|");

                  englishResponse =
                    matchedIndices.length > 0
                      ? matchedIndices
                          .filter((index) => index !== -1)
                          .map((index) => choices[index])
                          .join(question.FieldDelimiter)
                      : question.ResponseText
                      ? question.ResponseText
                      : "";

                  let responseData = question?.Response.filter(
                    (item: { Selected: any }) => item.Selected
                  ).map((item: { value: any }) => item.value);
                  if (
                    question.IsNoneOfTheAboveEnabled &&
                    responseData?.includes(question?.NoneOfTheAboveText)
                  ) {
                    if (languageData) {
                      try {
                        languageData = JSON.parse(languageData);
                        if (Array.isArray(languageData)) {
                          const engDataJson =
                            languageData.filter(
                              (item: any) => item.LanguageCode === 120000000
                            ) || [];
                          const englishChoicesMatch = engDataJson.find(
                            (item: { TextCode: any }) =>
                              item.TextCode === question.NoneOfTheAboveTextCode
                          );
                          if (englishChoicesMatch) {
                            englishResponse = englishChoicesMatch.TextValue;
                          }
                        } else {
                          console.error(
                            "languageData is not an array:",
                            languageData
                          );
                        }
                      } catch (error) {
                        console.error("Error parsing languageData:", error);
                      }
                    }
                  }
                  if (question.IsOtherEnabled && question.OtherResponse) {
                    englishResponse += englishResponse
                      ? `${question.FieldDelimiter} ${question.OtherResponse}`
                      : question.OtherResponse;
                  }
                } else {
                  const matchedIndex = question.surveyQuestionChoices.findIndex(
                    (choice) => choice.choiceText === question.Response
                  );
                  question.EnglishChoice =
                    Array.isArray(question.EnglishChoice) &&
                    question.EnglishChoice.length > 0
                      ? [question.EnglishChoice.join(question.FieldDelimiter)]
                      : [];

                  englishResponse = question.EnglishChoice?.[0]
                    ? question.EnglishChoice[0].split(question.FieldDelimiter)[
                        matchedIndex
                      ] ??
                      (question.ResponseText || "")
                    : question.ResponseText || "";
                }
                return {
                  ...question,
                  EnglishResponse: englishResponse,
                };
              }
            );

            return {
              ...el,
              surveyQuestions: updatedSurveyQuestions,
            };
          }),
      };
    } else {
      // finalData = sourceData;
      finalData = {
        ...sourceData,
        LastUpdatedPageNumber: parsedData.lastUpdatedPageNumber,
        PreferredLanguage: languageId,
        surveyPages: sourceData.surveyPages
          .filter((el: any) =>
            parsedData.pages.some((pg: any) => pg.pageNumber === el.pageNumber)
          )
          .map((el: any) => {
            const updatedSurveyQuestions = el.surveyQuestions.map(
              (question: any) => {
                if (!question.surveyQuestionChoices) {
                  console.error(
                    "surveyQuestionChoices is missing for:",
                    question
                  );
                  return {
                    ...question,
                    // EnglishResponse: question.ResponseText,
                  };
                }
                let englishResponse = "";
                if (question.questionType == 120000001) {
                  const matchedIndices = question.Response.map((responseItem) =>
                    question.surveyQuestionChoices.findIndex(
                      (choice) => choice.choiceText === responseItem.value
                    )
                  );
                  question.EnglishChoice =
                    Array.isArray(question.EnglishChoice) &&
                    question.EnglishChoice.length > 0
                      ? [question.EnglishChoice.join(question.FieldDelimiter)]
                      : [];
                  // console.log(
                  //   "question.EnglishChoice***",
                  //   question.EnglishChoice
                  // );
                  const choices = question.EnglishChoice[0].split("|");

                  englishResponse =
                    matchedIndices.length > 0
                      ? matchedIndices
                          .filter((index) => index !== -1)
                          .map((index) => choices[index])
                          .join(question.FieldDelimiter)
                      : question.ResponseText
                      ? question.ResponseText
                      : "";

                  let responseData = question?.Response.filter(
                    (item: { Selected: any }) => item.Selected
                  ).map((item: { value: any }) => item.value);
                  if (
                    question.IsNoneOfTheAboveEnabled &&
                    responseData?.includes(question?.NoneOfTheAboveText)
                  ) {
                    if (languageData) {
                      try {
                        languageData = JSON.parse(languageData);
                        if (Array.isArray(languageData)) {
                          const engDataJson =
                            languageData.filter(
                              (item: any) => item.LanguageCode === 120000000
                            ) || [];
                          const englishChoicesMatch = engDataJson.find(
                            (item: { TextCode: any }) =>
                              item.TextCode === question.NoneOfTheAboveTextCode
                          );
                          if (englishChoicesMatch) {
                            englishResponse = englishChoicesMatch.TextValue;
                          }
                        } else {
                          console.error(
                            "languageData is not an array:",
                            languageData
                          );
                        }
                      } catch (error) {
                        console.error("Error parsing languageData:", error);
                      }
                    }
                  }

                  if (question.IsOtherEnabled && question.OtherResponse) {
                    englishResponse += englishResponse
                      ? `${question.FieldDelimiter} ${question.OtherResponse}`
                      : question.OtherResponse;
                  }
                } else {
                  const matchedIndex = question.surveyQuestionChoices.findIndex(
                    (choice) => choice.choiceText === question.Response
                  );
                  question.EnglishChoice =
                    Array.isArray(question.EnglishChoice) &&
                    question.EnglishChoice.length > 0
                      ? [question.EnglishChoice.join(question.FieldDelimiter)]
                      : [];

                  englishResponse = question.EnglishChoice?.[0]
                    ? question.EnglishChoice[0].split(question.FieldDelimiter)[
                        matchedIndex
                      ] ??
                      (question.ResponseText || "")
                    : question.ResponseText || "";
                }

                return {
                  ...question,
                  EnglishResponse: englishResponse,
                };
              }
            );

            return {
              ...el,
              surveyQuestions: updatedSurveyQuestions,
            };
          }),
      };
    }
    const validate = ajv.compile(sourceSchema);
    const valid = validate(finalData);
    if (valid) {
      return finalData;
    } else {
      // alert('Data sync error');
      return false;
    }
    // return sourceData;
  };

  const formatMultichoiceResponse = (response: any) => {
    var parsedRes = Array.isArray(response)
      ? response.map((res: any) => {
          if (res && typeof res === "string") {
            return {
              label: res.trim(),
              Index: res.trim(),
              value: res.trim(),
              Selected: true,
            };
          } else {
            return {
              label: "",
              Index: "",
              value: "",
              Selected: false,
            };
          }
        })
      : [];
    return parsedRes;
  };
  const formatMultichoiceResponseText = (response: any) => {
    var parsedRes = Array.isArray(response) ? response.toString() : "";
    return parsedRes;
  };

  const syncQuestionChanges = (qData: any) => {
    setSourceData((prvState: any) => {
      let updatedSourceData = { ...prvState };
      let updatedSurveyPages = updatedSourceData.surveyPages || [];
      for (let page of updatedSurveyPages) {
        let surveyQuestions = page.surveyQuestions || [];
        for (let question of surveyQuestions) {
          if (question.questionCode === qData.questionCode) {
            question.OtherResponse = qData.othersResponse;
            if (qData.questionType === 120000001) {
              question.Response = formatMultichoiceResponse(qData.response);
              let responseData = qData?.responseCode || "";
              if (responseData) {
                const updatedRresponseData = responseData
                  .split(",")
                  .map((item) => item.trim())
                  .filter((item) => item !== "");
                const isNumericResponse = updatedRresponseData.every(
                  (item) => !isNaN(item)
                );

                if (isNumericResponse) {
                  responseData = updatedRresponseData
                    .map(Number)
                    .sort((a, b) => a - b)
                    .join(qData.fielddelimiter);
                } else {
                  responseData = updatedRresponseData.join("|");
                }
              }
              //  question.ResponseCode = responseData;
              question.ResponseText = formatMultichoiceResponseText(
                qData.response
              );
              question.EnglishResponse = qData.englishResponse;
              if (qData.othersResponse) {
                if (responseData) {
                  responseData += qData.fielddelimiter + qData.othersResponse;
                } else {
                  responseData = qData.othersResponse;
                }
              }

              question.ResponseCode = responseData;
            } else {
              let responseData = qData?.responseCode || "";
              question.Response = qData.response;
              question.ResponseCode = responseData;
              question.EnglishResponse = qData.englishResponse;
              question.ResponseText = qData.response;

              if (qData.othersResponse) {
                responseData = qData.othersResponse;
              }

              question.ResponseCode = responseData;
              if (qData.response?.includes(qData.othersResponse)) {
                question.Response = null;
              }
            }

            question.CompletionStatus = qData.completionStatus;
            break;
          }
        }
      }

      updatedSourceData.surveyPages = updatedSurveyPages;
      console.log(updatedSourceData);
      return updatedSourceData;
    });
  };

  useEffect(() => {
    console.log(sourceData);
  }, [sourceData]);

  return { parseFromSource, parseToSource };
};

/*
{
    "activityId":PatientActivityID,
    "activityName":PatientActivityName,
    "activityStatus":ActivityStatus,
    "activityType":ActivityType,
    "member":{
        "id":PatientID,
        "formatedValue": PatientName,
        "entity": ''
    },
    "isPartialSaveEnabled": IsPartialSaveEnabled,
    "pages" : $distinct(PatientActivityDetails.{
        "pageNumber" : PageNumber,
        "saveOnNav" : false,
        "questionGroups" : [{
        "questionGroupId": "g1",
        "questionGroup": "Qus Group",
        "questionSection": "Qus Sec",
        "questionSubSection": "Qus SubSection"  ,
        "questions" : $filter($$.PatientActivityDetails[*], function($item) {$item.PageNumber = PageNumber})[].{
            "id": PatientActivityDetailID,
            "questionNumber": QuestionNumber,
            "questionCode": QuestionCode,
            "questionText": Question,
            "responseType": QuestionType, 
            "responseDataType": ColumnDataType,
            "response": Response ? Response : [],
            "answerCodes": AnswerCodes,
            "choices":Choices.{
                "choiceCode":$,
                "choiceText":$,
                "choiceTextInDefaultLanguage":$,
                "scoringValue": 0,
                "choiceOrder": 1
            },
            "completionStatus":CompletionStatus,
            "hasOthers":IsOtherEnabled,
            "othersResponse": OtherResponse,
            "hasNOA":IsNoneOfTheAboveEnabled,
            "noaText":NoneOfTheAboveText,
            "isRequired":IsMandatory,
            "isPartialSaveEnabled":IsPartialSaveEnabled,
            "validationSetting":AdditionalSetting,
            "isVisible":false,
            "hasVisibilityRule": false,
            "visibilityRule": null,
            "description":Description
            }
        }]
    })
        
    

}
*/
